import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';

import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { MantenedorUsuariosService } from 'src/app/services/mantenedor-usuarios/mantenedor-usuarios.service';

export interface DialogData 
{
    sexo: any
    estadoCivil: any
    regiones: any
    regionesDirDat: any
    comunas: any
    comunasDirDat: any
    roles: any
    recarga: boolean
    tipoAfiliado: any
    prevision: any
    sistemaSalud: any
    idEjecutivo: any
}
declare const Rut: any;
@Component({
    selector: 'dialog-overview-example-dialog',
    templateUrl: '../../pages/mantenedor-usuarios/crear-usuario.component.html',
    styleUrls: ['../../pages/mantenedor-usuarios/mantenedor-usuarios.component.css']
})
export class DialogCreaUsuario
{  
    usuario: any = { nombres:null, apellidoPaterno: null, apellidoMaterno: null, rut: null, correo: null,
                     tipoAfiliado: null, estadoAfiliado: 'Afiliado', sexo: null, estadoCivil: null,
                     fechaIngreso: null, fechaNacimiento: null, fonoFijo: null, fonoMovil: null, prevision: null ,
                     direccion: { descripcion: null, comuna: null, region: null, numero: null, sistemaSalud: null ,
                     descripcionAdicional: null }, datosLaborales: { tipoUnidad: null, unidad: null, 
                     calidadJuridica: null, estamento: null, direccion: { descripcion: null, comuna: null, 
                     region: null, numero: null, descripcionAdicional: null } }, rol: null,idEjecutivo: null }

    constructor( public dialogRef: MatDialogRef<DialogCreaUsuario>, private dialog: MatDialog, 
                 @Inject(MAT_DIALOG_DATA) public data: DialogData, 
                 private mantenedorService: MantenedorUsuariosService) 
    { 
        this.data.recarga = false 
        this.data.idEjecutivo = localStorage.getItem("idUsuario")
        this.data.tipoAfiliado = ['ACTIVO', 'PASIVO']
        this.data.sexo = [ { descripcion: 'Hombre', id: '1' }, { descripcion: 'Mujer', id: '2' } ]        
    }

    ngOnInit(): void {this.loadData()}

    loadData()
    {
        let vm = this

        this.mantenedorService.traeEstadoCivil().then( estados => vm.data.estadoCivil = estados )
        this.mantenedorService.traePrevision().then( previsiones => vm.data.prevision = previsiones )
        this.mantenedorService.traeSistemaSalud().then( sistemas => vm.data.sistemaSalud = sistemas )
        this.mantenedorService.traeRegiones().then
        ( regiones => { vm.data.regiones = regiones, vm.data.regionesDirDat = regiones } )
        this.mantenedorService.traeRoles().then( roles => vm.data.roles = roles )
    }

    traeComunas()
    {
        let vm = this

        this.data.comunas = []

        this.mantenedorService.traeComunas(this.usuario.direccion.region).then( comunas => vm.data.comunas = comunas )
    }

    traeComunasDirDat()
    {
        let vm = this
        
        this.data.comunasDirDat = []

        this.mantenedorService.traeComunas(this.usuario.datosLaborales.direccion.region)
        .then( comunas => vm.data.comunasDirDat = comunas )
    }

    crearUsuario(): void 
    {
        let vm = this
        let fn = new Date(this.usuario.fechaNacimiento);
        let fi = new Date();
        if(this.usuario.fechaIngreso){
            let fi = new Date(this.usuario.fechaIngreso);
        }
    
        if(this.data.idEjecutivo){
            this.usuario.idEjecutivo = this.data.idEjecutivo
        }
        if((this.usuario.fechaIngreso) && fn.getTime() > fi.getTime()){   
            this.openAlertDialog('La fecha de nacimiento debe ser menor a la fecha de ingreso', 'btn-danger');        
        }

     //   if( fn.getTime() < fi.getTime()){      
            if(Rut( this.usuario.rut)){      
                this.usuario.roltmp = []            
                if(this.usuario.rol !=null && this.usuario.rol.length > 0) {
                    this.usuario.rol.forEach( (element: any, i: number) =>{
                        this.usuario.roltmp.push( { id:element, idUsuarioRol:element } ) 
                    }) 
                }       
                this.usuario.rol=[]      
                if(this.usuario.roltmp !=null && this.usuario.roltmp.length > 0) {
                    this.usuario.rol= this.usuario.roltmp
                }
                let fechaNacimiento = this.usuario.fechaNacimiento.split('-')[2] + '-' + 
                                    this.usuario.fechaNacimiento.split('-')[1] + '-' + 
                                    this.usuario.fechaNacimiento.split('-')[0]
                
                let fechaIngreso =null
                if(this.usuario.fechaIngreso){
                    fechaIngreso = this.usuario.fechaIngreso.split('-')[2] + '-' + 
                    this.usuario.fechaIngreso.split('-')[1] + '-' + 
                    this.usuario.fechaIngreso.split('-')[0]
                }
               
                
                this.usuario.fechaNacimiento = fechaNacimiento, this.usuario.fechaIngreso = fechaIngreso

                this.mantenedorService.creaUsuario(this.usuario).then
                ( 
                    () => 
                    {
                        vm.openAlertDialog('El usuario se ha creado exitosamente.', 'btn-success')     

                        vm.data.recarga = true
                        vm.dialogRef.close()   
                    }
                )
                .catch(error => 
                { 
                    console.log(error) 

                    vm.openAlertDialog('Ha ocurrido un error al crear el Usuario', 'btn-danger')    
                    vm.dialogRef.close() 
                })
            }else{
                this.openAlertDialog('El RUT del usuario es incorrecto. Favor Revisar', 'btn-danger') 
            }
        /*}else{
            this.openAlertDialog('La fecha de nacimiento debe ser menor a la fecha de ingreso', 'btn-danger') 
        } */
    }

    onCancelarClick(): void { this.dialogRef.close() }  
    
    openAlertDialog(mensaje: string, clase: string)  
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }
}